import {Component, DestroyRef, inject, OnInit} from '@angular/core';
import {FormHelperService} from '../../shared/services/form-helper.service';
import {models} from '../../shared/models';
import {ErrorService, FormSaveHelper} from '@vasio-nl/valow';
import {MessageService} from 'primeng/api';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {catchError} from 'rxjs';
import {notNull} from '../../shared/utils';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss',
})
export class SettingsComponent implements OnInit {
  destroyRef = inject(DestroyRef);
  formHelperService = inject(FormHelperService);
  messageService = inject(MessageService);
  errorService = inject(ErrorService);

  formContainer = this.formHelperService.getFormContainer(models.Settings, fb => ({
    id: fb.modelField('id'),
    defaultConfirmationTextEN: fb.modelField('defaultConfirmationTextEN'),
    defaultConfirmationTextNL: fb.modelField('defaultConfirmationTextNL'),
    overrideConfirmationStartDate: fb.modelField('overrideConfirmationStartDate'),
    overrideConfirmationEndDate: fb.modelField('overrideConfirmationEndDate'),
    overrideConfirmationTextEN: fb.modelField('overrideConfirmationTextEN'),
    overrideConfirmationTextNL: fb.modelField('overrideConfirmationTextNL'),
  }));
  public form = this.formContainer.form;
  public saveHelper = new FormSaveHelper(this.formContainer, this.messageService);

  ngOnInit(): void {
    this.formContainer.form.controls.id.setValue('1');
    this.saveHelper.onSave$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe();

    this.formHelperService
      .getData(this.formContainer.model, this.formContainer.queryFields, '1')
      .pipe(
        catchError(err => this.errorService.HandleGraphQLError('Laden van instellingen')),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(data => {
        const preparedData = this.formContainer.prepareDataForForm(notNull(data.settings));
        this.formHelperService.updateFormFromModel(this.form, preparedData);
      });
  }
}
